import React, { useState, useRef } from 'react'
import PageLayout from '@layouts/PageLayout'
import { useLocalization } from '@contexts/LocalizationContext'
import { Button, Input, Table } from 'antd'
import Fetch from '@components/CRUD/Fetch'
import { useParams } from 'react-router-dom'

import PropTypes from 'prop-types'
import { client } from '@utils/client'
import moment from 'moment'

const HistoryCoin = () => {
  const { t } = useLocalization()
  const defaultPage = 1
  const defaultPageSize = 10
  const fetchRef = useRef(null)
  const [page, setpage] = useState(defaultPage)
  const [pageSize, setpageSize] = useState(defaultPageSize)
  const params = useParams()
  const [keyword, setKeyword] = useState()

  const [userData, setUserData] = useState()

  const fetch = async ({ page, pageSize, keyword }) => {
    console.log(keyword)
    const result = await client
      .get(`/transaction/${params.id}`, {
        params: {
          page: page,
          limit: pageSize,
          keyword: keyword,
        },
      })
      .then((res) => res.data)
    console.log(result)
    const resultUser = await client
      .get(`/users/${params.id}`)
      .then((res) => res.data)

    setUserData(
      `${resultUser.profile.firstname}  ${resultUser.profile.lastname}`
    )

    return result
  }

  const columns = [
    {
      title: t('rewards.point.history.column.createdAt'),
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 100,
      render: function code(createdAt) {
        return moment(createdAt).format('YYYY-MM-DD')
      },
    },
    {
      title: t('rewards.point.history.column.desc'),
      dataIndex: 'desc',
      key: 'desc',
      width: 200,
    },
    {
      title: t('rewards.point.history.column.amount'),
      dataIndex: 'amount',
      key: 'amount',
      width: '60%',
    },
  ]

  const handleChange = (pagination) => {
    setpage(pagination.current)
    setpageSize(pagination.pageSize)
  }

  const style = {
    btnAddData: { borderRadius: '5px', width: '165px', height: '40px' },
    divSearch: {
      width: '100%',
      display: 'flex',
      gap: '20px',
      marginBottom: '20px',
    },
    btnSearch: { borderRadius: '5px', width: '136px', height: '40px' },
    inputSearch: { width: '100%', borderRadius: '6px', height: '40px' },
  }

  return (
    <>
      <Fetch
        fetch={fetch}
        params={{ page, pageSize, keyword, userData }}
        ref={fetchRef}
      >
        {({ data, total }) => (
          <>
            <PageLayout title={userData} shownBack={false}>
              <div style={style.divSearch}>
                <SearchInput fetchData={(keyword) => setKeyword(keyword)} />
              </div>

              <Table
                rowKey="id"
                columns={columns}
                dataSource={data}
                onChange={handleChange}
                pagination={{
                  defaultCurrent: defaultPageSize,
                  defaultPageSize: defaultPageSize,
                  current: page,
                  pageSize,
                  total,
                }}
              ></Table>
            </PageLayout>
          </>
        )}
      </Fetch>
    </>
  )
}
const SearchInput = ({ fetchData }) => {
  const { t } = useLocalization()
  const [keyword, setKeyword] = useState()
  const style = {
    btnSearch: { borderRadius: '5px', width: '136px', height: '40px' },
    inputSearch: { width: '100%', borderRadius: '6px', height: '40px' },
  }

  return (
    <>
      <Input
        defaultValue={keyword}
        placeholder=""
        style={style.inputSearch}
        onChange={(e) => setKeyword(e.target.value)}
      />

      <Button
        style={style.btnSearch}
        type="primary"
        key="reload"
        onClick={() => fetchData(keyword)}
      >
        {t('rewards.list.search')}
      </Button>
    </>
  )
}

SearchInput.propTypes = {
  fetchData: PropTypes.func,
}
export default HistoryCoin
